
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { AdminInvoiceRoute } from '@/modules/invoice/routes/admin-invoice.route'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminInvoiceCreateButton extends Vue {
  constructor(
    private readonly routes: AdminInvoiceRoute
  ) {
    super()
  }

  @Prop({ default: 'جدید' }) label?: string

}
